import { Caption } from '@remotion/captions';

/**
 * caption payload를 JSON으로 직렬화했을 때 byte 크기를 계산한다.
 * @param captions 저장 대상 caption 배열
 * @returns utf-8 기준 payload 크기(byte)
 */
export const calculateCaptionAssetSize = (captions: Caption[]): number => {
  const payload = JSON.stringify(captions);

  if (typeof Buffer !== 'undefined') {
    return Buffer.byteLength(payload, 'utf-8');
  }

  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(payload).length;
  }

  return payload.length;
};
